import React, { Component } from 'react';

import './NossoAnoEventos.scss';

import { Link } from "react-router-dom";
import { Helmet } from "react-helmet";
import Fade from 'react-reveal/Fade';

// import OwlCarousel from 'react-owl-carousel2';
// import '../../../node_modules/react-owl-carousel2/src/owl.carousel.css';
// import '../../../node_modules/react-owl-carousel2/lib/styles.css';

import "react-responsive-carousel/lib/styles/carousel.min.css";
import { Carousel } from 'react-responsive-carousel';

import {
    Accordion,
    AccordionItem,
    AccordionItemTitle,
    AccordionItemBody,
} from 'react-accessible-accordion';

import {
    Dispatcher,
    Actions,
    Events
} from '../../flux';

import {
	images
} from '../../settings';

import {
	DelayLink
} from '../../components/';

class NossoAnoEventos extends Component {

	constructor() {
		super();

        this.images = images;

        this.state = {
            width: window.innerWidth
        };

	    this.globalTransition = this.globalTransition.bind(this);
	}

	componentWillMount() {
    	Actions.menuIntern();
    	Actions.logoIntern();
    	Actions.showFooter();
		Actions.emitPage('7.2 Eventos');
    }

    componentWillUnmount() {
	}

    componentDidMount() {
    }

    globalTransition() {
    	Actions.globalTransition();
    }

	render() {
        const { width } = this.state;
        const isMobile = width <= 769;

		var classItem = [
			'view',
			'nossoano-eventos'
		];

		// Icon Columns - Assembleia
		const options = {
		    items: 1,
		    nav: true,
		    bullets: true,
		    rewind: true
		};

        return (

			<div className="views" id="scene">
			
				<Helmet>
	                <title>7.2 Eventos - Relatório Anual 2018 | ANBIMA</title>
	            </Helmet>

				<div className="views_container">

		        	<article className={ classItem.join(' ') }>

		        		<header className="views__header">
		        			<div className="container">
				        		<h1><span>7.2</span> Eventos</h1>
		        			</div>
		        		</header>

		        		<header className="views__breadcrumb">
		        			<div className="container">
				        		<p>Home / Nosso ano</p>
		        			</div>
		        		</header>

		        		<div className="views__content first__view row">
			        		<div className="container">
				        		<div className="column">
				        			<Fade bottom>
				        				<p>Mais de 2.300 pessoas participaram dos eventos organizados em 2018. O destaque foi o Congresso Brasileiro de Mercado de Capitais, que reuniu mais de mil participantes para ricas discussões.</p>
				        			</Fade>
				        		</div>
			        		</div>
		        		</div>
 
		        		<div className="views__content photos__view congresso_photos__text row"> 
			        		<div className="container">
				        		<div className="column column--text">
				        			<h3 className="blue_title">Congresso Brasileiro de Mercado de Capitais</h3>
				        			<p>
				        				<strong>Setembro | 1.075 participantes</strong>
				        				<br /><br />
				        				Promovemos em conjunto com a B3 o maior evento do mercado de capitais brasileiro. Realizado no Memorial da América Latina, em São Paulo, o congresso contou com debates sobre desafios e tendências para o segmento, além da presença de grandes nomes dos mercados nacional e internacional. A agenda de propostas elaborada pelas duas entidades, com medidas para fortalecer os mecanismos de financiamento de longo prazo, foi o pano de fundo de várias discussões.
				        			</p>
				        		</div>
			        		</div>
		        		</div>

		        		<div className="views__content photos__view congresso_photos row">
			        		<div className="container">
				        		<div className="column">
						            <Carousel showStatus={false} showThumbs={false} infiniteLoop={true} ref="gallery1"> 
							            <div>
				        					<img src={ this.images.nosso_ano_01_setembro1 } />
						            	</div>
							            <div>
				        					<img src={ this.images.nosso_ano_01_setembro3 } />
						            	</div>
							            <div>
				        					<img src={ this.images.nosso_ano_01_setembro4 } />
						            	</div>
							            <div>
				        					<img src={ this.images.nosso_ano_01_setembro2 } />
						            	</div>
									</Carousel>
				        		</div>
		        			</div>
		        		</div>
 
		        		<div className="views__content photos__view row">
			        		<div className="container">
			        			<Fade bottom>
					        		<div className="column column--half text-center">
					        			<img src={ this.images.nosso_ano_03_marco1 } />
					        		</div>
					        		<div className="column column--half column--padding column--text">
					        			<h3 className="blue_title">Exercício simulado de cibersegurança</h3>
					        			<p>
					        				<strong>Março | 25 participantes</strong>
					        				<br /><br />
					        				Exercício simulando ataques cibernéticos para testar os planos de resposta das instituições do mercado. 
					        			</p>
					        		</div>
			        			</Fade>
		        			</div>
		        		</div>
 
		        		<div className="views__content photos__view photos__view--almoco-guardia row">
			        		<div className="container">
			        			<Fade bottom>
					        		<div className="column column--half column--padding column--text">
					        			<h3 className="blue_title">Almoço com Eduardo Guardia</h3>
					        			<p>
					        				<strong>Abril | 33 participantes</strong>
					        				<br /><br />
					        				Reunião com o ministro da Fazenda, Eduardo Guardia, seguida de coletiva de imprensa.
					        			</p>
					        		</div>
					        		<div className="column column--half text-center">
					        			<img src={ this.images.nosso_ano_04_abril1 } />
					        		</div>
			        			</Fade>
		        			</div>
		        		</div>
 
		        		<div className="views__content photos__view posse_photos row"> 
			        		<div className="container">
				        		<div className="column text-center">
						            <Carousel showStatus={false} showThumbs={false} infiniteLoop={true} ref="gallery2"> 
							            <div>
				        					<img src={ this.images.nosso_ano_06_junho1 } />
						            	</div>
							            <div>
				        					<img src={ this.images.nosso_ano_06_junho2 } />
						            	</div>
							            <div>
				        					<img src={ this.images.nosso_ano_06_junho3 } />
						            	</div>
									</Carousel>
				        		</div>
		        			</div>
		        		</div>

		        		<div className="views__content photos__view posse_title row"> 
			        		<div className="container">
				        		<div className="column column--text">
				        			<h3 className="blue_title">Posse da Diretoria 2018/2020 </h3>
				        			<p>
				        				<strong>Junho | 210 participantes</strong>
				        				<br /><br />
				        				Cerimônia de posse do novo presidente Carlos Ambrósio, vice-presidentes e diretores que assumiram a Diretoria em abril, além da despedida do ex-presidente Robert van Dijk.
				        			</p>
				        		</div>
		        			</div>
		        		</div>
 
		        		<div className="views__content photos__view row">
			        		<div className="container">
			        			<Fade bottom>
					        		<div className="column column--half column--padding column--text">
					        			<h3 className="blue_title">Open banking: tendências e desafios</h3>
					        			<p>
					        				<strong>Junho | 121 participantes</strong>
					        				<br /><br />
					        				A discussão teve foco no aprimoramento do atendimento personalizado aos clientes.
					        			</p>
					        		</div>
					        		<div className="column column--half text-center">
					        			<img src={ this.images.nosso_ano_06_2_junho1 } />
					        		</div>
			        			</Fade>
		        			</div>
		        		</div>
 
		        		<div className="views__content photos__view row">
			        		<div className="container">
			        			<Fade bottom>
					        		<div className="column column--padding column--text">
					        			<h3 className="blue_title">Reuniões com os economistas dos presidenciáveis</h3>
					        			<p>
					        				<strong>Junho e julho | 134 participantes</strong>
					        				<br /><br />
					        				Foram realizados quatro encontros com os economistas responsáveis pelos programas de governo dos principais candidatos à Presidência da República.
					        			</p>
					        		</div>
			        			</Fade>
		        			</div>
		        		</div>
 
		        		<div className="views__content photos__view row">
			        		<div className="container">
			        			<Fade bottom>
					        		<div className="column column--half text-center">
					        			<img src={ this.images.nosso_ano_08_agosto1 } />
					        		</div>
					        		<div className="column column--half column--padding column--text">
					        			<h3 className="blue_title">Agenda aberta</h3>
					        			<p>
					        				<strong>Agosto | 20 participantes</strong>
					        				<br /><br />
					        				Apresentação das iniciativas em certificação e educação de investidores, além dos resultados da pesquisa <span onClick={ this.globalTransition }><DelayLink to="/nosso-ano/principais-iniciativas" delay={1000}>Raio X do Investidor Brasileiro</DelayLink></span>, para análise e sugestões de especialistas e profissionais do mercado.
					        			</p>
					        		</div>
			        			</Fade>
		        			</div>
		        		</div>
 
		        		<div className="views__content photos__view photos__view--webinar row">
			        		<div className="container">
			        			<Fade bottom>
					        		<div className="column column--half column--padding column--text">
					        			<h3 className="blue_title">Webinar de supervisão: convênio de fundos com a CVM</h3>
					        			<p>
					        				<strong>Outubro | 648 participantes</strong>
					        				<br /><br />
					        				Apresentação do convênio de aproveitamento da supervisão de fundos firmado com a autarquia.
					        			</p>
					        		</div>
					        		<div className="column column--half text-center">
					        			<img src={ this.images.nosso_ano_10_outubro1 } />
					        		</div>
			        			</Fade>
		        			</div>
		        		</div>
 

		        		<div className="views__content photos__view photos__view--dabate-text row">
			        		<div className="container">
			        			<Fade bottom>
					        		<div className="column column--text">
					        			<h3 className="blue_title">ANBIMA Debate: Raio X do Investidor Brasileiro</h3>
					        			<p>
					        				<strong>Outubro | 110 participantes</strong>
					        				<br /><br />
					        				Bate-papo sobre os resultados da pesquisa e sobre como as instituições financeiras podem se comunicar melhor com as pessoas e contribuir para uma maior formação de poupança no país. O ANBIMA Debate é um evento exclusivo para os associados com foco na troca e disseminação de informações sobre temas atuais e relevantes ao mercado.
					        			</p>
					        		</div>
			        			</Fade>
		        			</div>
		        		</div>

		        		<div className="views__content photos__view photos__view--debate row">
			        		<div className="container">
			        			<Fade bottom>
					        		<div className="column text-center">
					        			<img src={ this.images.nosso_ano_10_2_outubro1 } />
					        		</div>
			        			</Fade>
		        			</div>
		        		</div>

 
		        		<div className="views__content photos__view photos__view--webinar-codigo row">
			        		<div className="container">
			        			<Fade bottom>
					        		<div className="column column--half column--padding column--text">
					        			<h3 className="blue_title">Webinar: Código de Distribuição<br />de Produtos de Investimento</h3>
					        			<p>
					        				<strong>Novembro | 630 participantes</strong>
					        				<br /><br />
					        				Detalhamento do código, que entrou em vigor em 2019, e esclarecimento de dúvidas.
					        			</p>
					        		</div>
					        		<div className="column column--half text-center">
					        			<img src={ this.images.nosso_ano_11_novembro1 } />
					        		</div>
			        			</Fade>
		        			</div>
		        		</div>
 
		        		<div className="views__content photos__view photos__view--webinar-novo-codigo row">
			        		<div className="container">
			        			<Fade bottom>
					        		<div className="column column--half text-center">
					        			<img src={ this.images.nosso_ano_12_dezembro1 } />
					        		</div>
					        		<div className="column column--half column--padding column--text">
					        			<h3 className="blue_title">Webinar: Novo Código de Administração<br />de Recursos de Terceiros</h3>
					        			<p>
					        				<strong>Dezembro | 575 participantes</strong>
					        				<br /><br />
					        				Detalhamento do código, que entrou em vigor<br />em 2019, e esclarecimento de dúvidas.
					        			</p>
					        		</div>
			        			</Fade>
		        			</div>
		        		</div>

		        	</article>

        		</div>
    		</div>
    	);
	}
}

export { NossoAnoEventos };
